import React, { useState } from 'react';
import Header from './Header';
import ImpostosPage from './ImpostosPage';
import ConfiguracaoNfcePage from './ConfiguracaoNfcePage';
import ControlePage from './ControlePage';
import AmbientesPage from './AmbientesPage';

const cardsConfiguracoes = [
  { nome: 'Minha Empresa', icon: <span role="img" aria-label="empresa">🏢</span>, onClick: null },
  { nome: 'Ambientes', icon: <span role="img" aria-label="ambientes">🖨️</span>, onClick: 'abrirAmbientes' },
  { nome: 'Atendimentos', icon: <span role="img" aria-label="atendimentos">🤝</span>, onClick: null },
  { nome: 'Planos', icon: <span role="img" aria-label="planos">📦</span>, onClick: null },
  { nome: 'Finalizadoras', icon: <span role="img" aria-label="finalizadoras">💳</span>, onClick: null },
  { nome: 'Impostos', icon: <span role="img" aria-label="impostos">💰</span>, onClick: 'abrirImpostos' },
  { nome: 'NFC-e', icon: <span role="img" aria-label="nfce">🧾</span>, onClick: 'abrirNfce' },
  { nome: 'Etiquetas', icon: <span role="img" aria-label="etiquetas">🏷️</span>, onClick: null },
  { nome: 'App Permissões', icon: <span role="img" aria-label="permissoes">🔑</span>, onClick: null },
  { nome: 'Dispositivos', icon: <span role="img" aria-label="dispositivos">🖥️</span>, onClick: null },
  { nome: 'Ocorrências', icon: <span role="img" aria-label="ocorrencias">📋</span>, onClick: null },
  { nome: 'Controle', icon: <span role="img" aria-label="controle">🔢</span>, onClick: 'abrirControle' },
];

function MenuConfiguracoesPage({ usuario, empresaSelecionada, handleVoltar, handleSair }) {
  const [paginaImpostos, setPaginaImpostos] = useState(false);
  const [paginaNfce, setPaginaNfce] = useState(false);
  const [paginaControle, setPaginaControle] = useState(false);
  const [paginaAmbientes, setPaginaAmbientes] = useState(false);

  if (paginaImpostos) {
    return <ImpostosPage empresa={empresaSelecionada} usuario={usuario} onVoltar={() => setPaginaImpostos(false)} onSair={handleSair} />;
  }
  if (paginaNfce) {
    return <ConfiguracaoNfcePage empresa={empresaSelecionada} usuario={usuario} onVoltar={() => setPaginaNfce(false)} onSair={handleSair} />;
  }
  if (paginaControle) {
    return <ControlePage empresa={empresaSelecionada} usuario={usuario} onVoltar={() => setPaginaControle(false)} onSair={handleSair} />;
  }
  if (paginaAmbientes) {
    return <AmbientesPage empresa={empresaSelecionada} usuario={usuario} onVoltar={() => setPaginaAmbientes(false)} onSair={handleSair} />;
  }

  const handleCardClick = (onClick) => {
    if (onClick === 'abrirImpostos') setPaginaImpostos(true);
    else if (onClick === 'abrirNfce') setPaginaNfce(true);
    else if (onClick === 'abrirControle') setPaginaControle(true);
    else if (onClick === 'abrirAmbientes') setPaginaAmbientes(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={handleVoltar}
        onSair={handleSair}
      />
      <div className="flex flex-col items-center justify-center mt-16">
        <div className="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-3xl border border-blue-100 flex flex-col items-center">
          <h2 className="text-2xl font-bold text-blue-700 mb-8">Configurações</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full">
            {cardsConfiguracoes.map(card => (
              <div
                key={card.nome}
                className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300"
                onClick={() => handleCardClick(card.onClick)}
              >
                {card.icon}
                <span className="text-lg font-semibold text-blue-800">{card.nome}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MenuConfiguracoesPage; 